import { UpgradePlanModalUIKitInner } from "./UpgradePlanModalUIKitInner";
import type { UpgradePlanModalWrapperProps } from "./UpgradePlanModalWrapper";
import { UpgradePlanModalWrapper } from "./UpgradePlanModalWrapper";

export type UpgradePlanModalProps = Omit<
  UpgradePlanModalWrapperProps,
  "children"
>;

export const UpgradePlanModalUIKitComponent = (
  props: UpgradePlanModalProps,
) => (
  <UpgradePlanModalWrapper {...props}>
    {modalProps => <UpgradePlanModalUIKitInner {...modalProps} />}
  </UpgradePlanModalWrapper>
);
